import type { ModeratorInfo } from 'api/generated/models/ModeratorInfo';
import type { RoomModeratorRaw } from 'api/types';
import { roomInfoStore } from 'state/store';

/** Маппинг moderators из join/start API в формат room metadata. */
export const mapModeratorsFromJoin = (moderators?: ModeratorInfo[]): RoomModeratorRaw[] | undefined => {
    if (!moderators?.length) {
        return undefined;
    }

    return moderators.map((moderator) => ({
        type: moderator.userId ? 'USER' : 'GUEST',
        userId: moderator.userId != null ? String(moderator.userId) : null,
        identity: moderator.identity ?? null,
        moderatorType: moderator.moderatorType,
        role: moderator.moderatorType === 'PRIMARY' ? 'main' : 'moderator',
    }));
};

/** Кладем список модераторов в metadata до прихода LiveKit - иначе в комнате обычная роль до F5. */
export const applyModeratorsFromJoinResponse = (moderators?: RoomModeratorRaw[] | ModeratorInfo[]): void => {
    if (!moderators?.length) {
        return;
    }

    const first = moderators[0] as RoomModeratorRaw;
    const next =
        first.type === 'USER' || first.type === 'GUEST' || first.role
            ? (moderators as RoomModeratorRaw[])
            : mapModeratorsFromJoin(moderators as ModeratorInfo[]);

    if (!next?.length) {
        return;
    }

    const current = roomInfoStore.metadata ?? {};
    roomInfoStore.setMetadata({ ...current, moderators: next });
};
